import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import _ from "lodash";

const COLORS = d3.schemeCategory10; // 10 distinct colors

const BreakdownScoreBarGraph = ({ data }) => {
    const svgRef = useRef();

    useEffect(() => {
        if (!data || data.length === 0) return;

        const margin = { top: 50, right: 100, bottom: 80, left: 50 };
        const containerWidth = svgRef.current.parentElement.offsetWidth;
        const width = containerWidth - margin.left - margin.right - 200;
        const height = 400 - margin.top - margin.bottom;

        const svg = d3.select(svgRef.current);
        svg.selectAll('*').remove(); // Clear previous content

        const g = svg
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        const xScale = d3.scaleBand()
            .domain(data.map(d => d.question))
            .range([0, width])
            .padding(0.6);

        const yScale = d3.scaleLinear()
            .domain([0, 5])
            .range([height, 0]);

        const xAxis = d3.axisBottom(xScale);
        const yAxis = d3.axisLeft(yScale).ticks(5).tickFormat(d3.format("d"));

        g.append('g')
            .attr('transform', `translate(0,${height})`)
            .call(xAxis)
            .selectAll('text')
            .remove();

        g.append('g').call(yAxis);

        g.selectAll('.bar')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', 'bar')
            .attr('x', d => xScale(d.question))
            .attr('y', d => yScale(d.breakdownScore))
            .attr('width', xScale.bandwidth())
            .attr('height', d => height - yScale(d.breakdownScore))
            .attr('fill', (d, i) => COLORS[i % COLORS.length])
            .append('title')
            .text(d => `${d.question}\nScore: ${d.breakdownScore.toFixed(2)}`);

        // Legend
        const legendX = width + margin.left + 60;
        const legendY = (height - data.length * 20) / 2 + margin.top;
        const legend = svg.append('g')
            .attr('transform', `translate(${legendX}, ${legendY})`);

        data.forEach((d, i) => {
            const yOffset = i * 20;
            legend.append('rect')
                .attr('x', 0)
                .attr('y', yOffset)
                .attr('width', 12)
                .attr('height', 12)
                .attr('fill', COLORS[i % COLORS.length]);

            const maxLabelLength = 30;
            const labelText = d.question.length > maxLabelLength
                ? d.question.slice(0, maxLabelLength) + '…'
                : d.question;

            const text = legend.append('text')
                .attr('x', 20)
                .attr('y', yOffset + 10)
                .text(labelText)
                .style('font-size', '12px')
                .attr('alignment-baseline', 'middle');

            text.append('title').text(d.question); // Tooltip with full text
        });
    }, [data]);

    return (
        <div style={{ overflow: 'visible'}}>
            <svg ref={svgRef} style={{width: '100%', height: '400px', overflow: 'visible'}}/>
        </div>
    );
};

export default BreakdownScoreBarGraph;
